import { useQuery } from '@tanstack/react-query';

import { CerberusApi } from '@hcs/cerberus';
import {
  MsaHpiTimeSeriesDocument,
  MsaHpiTimeSeriesQuery,
  MsaHpiTimeSeriesQueryVariables,
} from '@hcs/types';

import { msaHpiTSQueryToCerberusHpiTS } from '../utils/cerberus-stats.utils';

const QUERY_KEY_MSA_HPI_TIME_SERIES = 'msa-hpi-time-series';

export const useMsaHpiTimeSeries = ({
  msaId,
  fromDate,
  toDate,
  enabled = true,
}: MsaHpiTimeSeriesQueryVariables & {
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: [QUERY_KEY_MSA_HPI_TIME_SERIES, msaId, fromDate, toDate],

    queryFn: async () => {
      const response = await CerberusApi.fetchQuery<
        MsaHpiTimeSeriesQuery,
        MsaHpiTimeSeriesQueryVariables
      >(MsaHpiTimeSeriesDocument, {
        msaId,
        fromDate,
        toDate,
      });
      return msaHpiTSQueryToCerberusHpiTS(response);
    },

    enabled,
  });
};
